import { createFileRoute } from '@tanstack/react-router'
import { CustomerApiTokensPage } from '@/features/customer/api-tokens'

export const Route = createFileRoute('/_authenticated/customer/api-tokens')({
  component: CustomerApiTokensPage,
})
